<template>
  <div class="columns is-multiline" v-if="data">
    <div class="column is-6">
      <BContainer
        :title="$t('title.yourInternalAuditScore', [this.data.name])"
        containerClass="is-paddingless"
      >
        <DonutChart :name="data.name" :data="data.score"></DonutChart>
      </BContainer>
    </div>
    <div class="column is-6">
      <BContainer
        :title="$t('title.yourScoreImprovement', [this.data.name])"
        containerClass="is-paddingless"
      >
        <BarChart
          v-if="historicalScoreData"
          :name="data.name"
          :data="historicalScoreData.scores"
          :labels="historicalScoreData.labels"
          :labelRotate="40"
        ></BarChart>
      </BContainer>
    </div>
    <div class="column is-6">
      <BContainer :title="$t('title.questionAnswerAnalysis')" containerClass="is-paddingless">
        <div
          class="columns is-paddingless is-multiline"
          style="padding-bottom:0.5rem !important; margin-top:0.5rem !important"
          v-if="isComponent"
        >
          <div class="column notification is-primary is-6-desktop is-12" style="margin-bottom:0px">
            <p class="has-text-weight-bold">{{ $t('title.totalQuestion') }}</p>
            <p class="title">{{ data.totalQuestion }}</p>
          </div>
          <div class="column notification is-warning is-6-desktop is-12" style="margin-bottom:0px">
            <p class="has-text-weight-bold">
              {{ $t('title.componentQuestion', [this.data.name]) }}
            </p>
            <p class="title">{{ data.yes + data.no }}</p>
          </div>
        </div>
        <div class="columns is-paddingless is-multiline">
          <div class="column notification is-info is-4-desktop is-12" style="margin-bottom:0px">
            <p class="has-text-weight-bold" v-if="data.name != 'Neta'">
              {{ $t('title.componentQuestion', [this.data.name]) }}
            </p>
            <p class="has-text-weight-bold" v-else>{{ $t('title.totalQuestion') }}</p>

            <p class="title">{{ data.yes + data.no }}</p>
          </div>
          <div class="column notification is-danger is-4-desktop is-12" style="margin-bottom:0px">
            <p class="has-text-weight-bold">{{ $t('button.no') }}</p>
            <p class="title">{{ data.no }}</p>
          </div>
          <div class="column notification is-success is-4-desktop is-12" style="margin-bottom:0px">
            <p class="has-text-weight-bold">{{ $t('button.yes') }}</p>
            <p class="title">{{ data.yes }}</p>
          </div>
        </div>
      </BContainer>
    </div>
    <div class="column is-6">
      <div class="column is-12 is-paddingless" style="padding-bottom:1.5rem !important">
        <BContainer
          :title="$t('title.whatIsScore', [this.data.name])"
          containerClass="is-paddingless"
        >
          <p>{{ data.description }}</p>
        </BContainer>
      </div>
      <div class="column is-12 is-paddingless" v-if="isComponent">
        <BContainer :title="$t('title.featuredDeficiencyQuestion')" containerClass="is-paddingless">
          <p v-if="data.no !== 0">{{ data.question }}</p>
          <p v-else>{{ $t('description.noFeaturedQuestion') }}</p>
        </BContainer>
      </div>
    </div>
  </div>
</template>
<script>
import { DonutChart, BarChart } from '../../../components'
import DateFilter from '@/_helpers/date.filter'

export default {
  props: {
    data: { type: Object, default: () => {} },
    isComponent: { type: Boolean, default: true }
  },
  components: { DonutChart, BarChart },
  data() {
    return {
      historicalScoreData: null
    }
  },
  watch: {
    data: {
      immediate: true,
      handler(newValue, oldValue) {
        if (newValue && newValue.lastScores) {
          const emptyDataCount = 4 - newValue.lastScores.length
          for (let index = 0; index < emptyDataCount; index++) {
            const element = { score: null, date: '' }
            newValue.lastScores.push(element)
          }
          this.historicalScoreData = {
            scores: newValue.lastScores.map(s => s.score),
            labels: newValue.lastScores.map(s => DateFilter.date(s.date))
          }
        } else {
          this.historicalScoreData = null
        }
      }
    }
  }
}
</script>
